module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/tablet-abfd4d02ac02dc2e788c8f0ace82fd2e.webp";